import { useMutation, useQuery } from "@tanstack/react-query";
import { alertEventService } from "../../services/alertEvent.service";

const { getAll, putAlertEvent } = alertEventService;
export const useGetAlertAndEvents = (userId: string) => {
	return useQuery({
		queryKey: ["sims-alert-events-get", userId],
		queryFn: () => getAll(userId),
		staleTime: 30_000,
		gcTime: 300_000,
	});
};

export const useDismissAll = (userId: string) => {
	return useMutation({
		mutationFn: (alertId?: string) => putAlertEvent(userId, alertId),
	});
};
